// src/admin/pages/Auth/AuthPage.js

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
// In base alla tua libreria, potrebbe essere "import jwt_decode from 'jwt-decode';"
import { jwtDecode } from "jwt-decode";

export default function AuthPage() {
  const navigate = useNavigate();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      setError("");
      setSuccessMessage("");

      const formData = new URLSearchParams();
      formData.append("username", username);
      formData.append("password", password);

      const res = await fetch(`${process.env.REACT_APP_API_URL}/login`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData,
      });
      if (!res.ok) {
        const errData = await res.json();
        throw new Error(errData.detail || "Errore di login");
      }

      const data = await res.json();
      localStorage.setItem("access_token", data.access_token);
      localStorage.setItem("refresh_token", data.refresh_token);

      const decoded = jwtDecode(data.access_token);

      // Reindirizzo in base al ruolo
      if (decoded.role === "super_admin") {
        navigate("/super_admin");
      } else if (decoded.role === "admin") {
        navigate("/admin/dashboard");
      } else if (decoded.role === "chef") {
        navigate("/chef");
      } else if (decoded.role === "waiter") {
        navigate("/waiter");
      } else {
        navigate("/");
      }
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <h2 style={styles.title}>Benvenuto, effettua il Login</h2>

        <form onSubmit={handleLogin} style={styles.form}>
          <div style={styles.formGroup}>
            <label style={styles.label}>Username</label>
            <input
              style={styles.input}
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div style={styles.formGroup}>
            <label style={styles.label}>Password</label>
            <input
              style={styles.input}
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <div style={styles.checkboxContainer}>
            <label style={styles.checkboxLabel}>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />
              <span>Ricordami</span>
            </label>
          </div>

          <button style={styles.button} type="submit">
            Login
          </button>
        </form>

        {error && <p style={styles.errorMsg}>{error}</p>}
        {successMessage && <p style={styles.successMsg}>{successMessage}</p>}
      </div>
    </div>
  );
}

// Stili con attenzione al mobile e font-size >= 16px
const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    background: "#f0f2f5",
    padding: "20px", // per un po' di respiro sui device più piccoli
  },
  card: {
    width: "100%",
    maxWidth: "400px",
    padding: "30px",
    background: "#fff",
    borderRadius: "8px",
    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)",
  },
  title: {
    textAlign: "center",
    marginBottom: "20px",
    fontFamily: "Arial, sans-serif",
    color: "#333",
    fontSize: "20px",
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  formGroup: {
    marginBottom: "15px",
    display: "flex",
    flexDirection: "column",
  },
  label: {
    marginBottom: "5px",
    fontWeight: "bold",
    color: "#555",
    fontSize: "14px",
  },
  input: {
    padding: "12px",
    fontSize: "16px", // >= 16px per evitare zoom
    borderRadius: "4px",
    border: "1px solid #ccc",
  },
  checkboxContainer: {
    marginBottom: "15px",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    color: "#555",
  },
  button: {
    width: "100%",
    padding: "14px",
    border: "none",
    borderRadius: "4px",
    backgroundColor: "#FF7F00",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  errorMsg: {
    color: "red",
    marginTop: "10px",
    fontSize: "14px",
    textAlign: "center",
  },
  successMsg: {
    color: "green",
    marginTop: "10px",
    fontSize: "14px",
    textAlign: "center",
  },
};
